var ToTop = function(){
	$(".back-to-top").on("click", function(){
		$("html, body").animate({
			"scrollTop": 0
		}, 300);
	});
	
	var topLimit = 1000;

	/*if($("#test").length) {
		if($("#test").next().next().next().next().length > 0) {
			topLimit = $("#test").next().next().next().next().offset().top;
		} else {
			topLimit = $("#test").offset().top + $("#test").outerHeight();
		}
	}*/

	$(window).on("scroll", function(){
		var topLimit = 1000;

		if($("#test").length) {
			if($("#test").next().next().next().next().length > 0) {
				topLimit = $("#test").next().next().next().next().offset().top;
			} else {
				topLimit = $("#test").offset().top + $("#test").outerHeight();
			}
		}

		if($(window).scrollTop() > topLimit) {
			$(".back-to-top").addClass("show");
		}
		else {
			$(".back-to-top").removeClass("show");
		}
	});
};

module.exports = ToTop;
